import { fromNow } from '@btime/helpers'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { useNonCompliance } from './_load/NonComplianceLoader'
import ChecklistPresenter from '../../../containers/checklists/ChecklistPresenter'
import FlexGrid from '../../../components/structure/FlexGrid'
import LabelValue from '../../../components/presentation/LabelValue'
import NonComplianceStatusTag from '../_shared/NonComplianceStatusTag'
import PlacePresenter from '../../../containers/places/PlacePresenter'

const Details = () => {
  const nonCompliance = useNonCompliance()
  const { t } = useTranslation('showNonCompliance')

  return (
    <FlexGrid justify="flex-start" align="flex-start" direction="column" paddingGutter={0.4}>
      <LabelValue label={t('status')}>
        <NonComplianceStatusTag name={nonCompliance.status} />
      </LabelValue>

      <FlexGrid justify="flex-start" align="flex-start" paddingGutter={1}>
        <LabelValue label={t('created')} value={fromNow(nonCompliance.insertedAt)} />
        <LabelValue
          label={nonCompliance.endDate ? t('concluded') : t('lastUpdate')}
          value={fromNow(nonCompliance.endDate || nonCompliance.updatedAt)}
        />
      </FlexGrid>

      <LabelValue label={t('placePerson')}>
        <PlacePresenter place={nonCompliance.place} weight="500" />
      </LabelValue>

      <LabelValue label={t('checklist')}>
        <ChecklistPresenter checklist={nonCompliance.question?.checklist} weight="500" />
      </LabelValue>

      <LabelValue label={t('category')} value={nonCompliance.question?.category?.name} />

      <LabelValue label={t('question')} value={nonCompliance.question?.name} />

      <LabelValue label={t('origin')} value={t('common:entity.' + nonCompliance.origin)} />
    </FlexGrid>
  )
}

export default Details
